export default "__VITE_ASSET__BuibXv9O__"